import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=13334d4f&scoped=true&"
import script from "./Button.vue?vue&type=script&lang=babel&"
export * from "./Button.vue?vue&type=script&lang=babel&"
import style0 from "./Button.vue?vue&type=style&index=0&id=13334d4f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13334d4f",
  null
  
)

export default component.exports